import { api } from "../index";
import { PaginatedResponse } from "../types";

export interface AdminUser {
  user_id: number;
  nome_completo?: string;
  email?: string;
  tipo?: string; // Admin | Comum | Colaborador | Selecionador (?)
  telefone?: string;
  whatsapp?: string;
  instituicao?: string;
  curso?: string;
  nivel_academico?: string;
  link_lattes?: string;
  created_at?: string;
}

export async function listUsers(
  token: string,
  page: number = 1,
  pageSize: number = 20
): Promise<PaginatedResponse<AdminUser>> {
  const r = await api.get("/users", {
    params: { page, pageSize },
    headers: { "X-CSRF-Token": token },
  });
  return r.data as PaginatedResponse<AdminUser>;
}

export async function getUserById(
  id: number,
  token: string
): Promise<AdminUser> {
  const r = await api.get(`/users/${id}`, {
    headers: { "X-CSRF-Token": token },
  });
  return r.data;
}

export async function updateUserType(id: number, tipo: string, token: string) {
  const r = await api.put(
    `/users/${id}/tipo`,
    { tipo },
    { headers: { "X-CSRF-Token": token } }
  );
  return r.data;
}

export async function deleteUserAccount(id: number, token: string) {
  const r = await api.delete(`/users/${id}`, {
    headers: { "X-CSRF-Token": token },
  });
  return r.data;
}
export async function getUserByEmail(
  email: string,
  token: string
): Promise<AdminUser> {
  const r = await api.get(`/users/email`, {
    params: { email },
    headers: { "X-CSRF-Token": token },
  });
  return r.data;
}
